import {Fragment} from "react";
import {IconButton} from "@mui/material";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {SaveDeviceVariantMutationVariables} from "./queries.generated";
import {useBoolState} from "../../hooks";
import SaveDialog from "./SaveDeviceVariantDialog";

type UpdateButtonProps = {
    id: number;
    name: string;
    onSuccess: () => void;
    domainName?: string;
};

export default ({id, name, domainName, onSuccess}: UpdateButtonProps) => {
    const [isOpen, open, close] = useBoolState();
    const initialData: SaveDeviceVariantMutationVariables = {
        id,
        name,
    };

    return (
        <Fragment>
            <IconButton color="primary" size="small" onClick={open}>
                <FontAwesomeIcon icon="pencil-alt" />
            </IconButton>
            <SaveDialog
                isOpen={isOpen}
                close={close}
                onSuccess={onSuccess}
                initialData={initialData}
                domainName={domainName}
            />
        </Fragment>
    );
};
